import React, { Fragment, useState, useCallback, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { tableColumns } from './LiveStreamData';
import { Button, Modal, Form } from 'react-bootstrap';
// import axios from 'axios';
import { toast } from 'react-toastify';
import { ServerPath } from '../../Constant';
import CreateLiveStream from './CreateLiveStream';
import EditLiveStream from './EditLiveStream';
import Search from '../../assets/images/svg/Search_SoS.svg';
import SearchIcon from '../../assets/images/svg/search_iconSos.svg';
import Calendar from '../../assets/images/svg/Calendar_SoS.svg';
import Filter from '../../assets/images/svg/Filter_SoS.svg';
import EditIcon from '../../assets/images/svg/editLearning.svg';
import Start from '../../assets/images/svg/play.svg';
import Stop from '../../assets/images/svg/stop.svg';
import ArchiveIcon from '../../assets/images/svg/archiveLearning.svg';
import ArchiveEnabled from '../../assets/images/svg/archiveEnabled.svg';

// Import date range picker
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { _axios } from '../../utils/axios';

// Custom styles for the data table
const tableStyles = `
  @keyframes blink{0%,100%{opacity:1}50%{opacity:0.2}}
  @keyframes spin{to{transform:rotate(360deg)}}
  .rdt_TableCell {
    padding: 4px 2px !important;
  }
  .rdt_TableHead {
    padding: 4px 2px !important;
  }
  .rdt_TableCol {
    padding: 4px 2px !important;
  }
  .rdt_TableCell[data-column-id="action"] {
    position: sticky !important;
    right: 0 !important;
    background-color: inherit !important;
    z-index: 1;
  }
  .rdt_TableHeadRow [data-column-id="action"] {
    position: sticky !important;
    right: 0 !important;
    background-color: inherit !important;
    z-index: 1;
  }
  .data-tables {
    overflow-x: auto;
  }
  .btn[title]:hover:after {
    content: attr(title);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 4px 8px;
    color: white;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
  }
  .btn[title] {
    position: relative;
  }
  .btn-link:hover {
    text-decoration: none !important;
  }
  .btn[disabled] {
    cursor: not-allowed;
  }
`;

// Main component
const LiveStreamTable = () => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelete, setToggleDelete] = useState(false);
    const [data, setData] = useState([]);
    const [showCreate, setShowCreate] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [editRowData, setEditRowData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [modalConfig, setModalConfig] = useState({
        type: '',
        title: '',
        message: '',
        stream_id: null,
        stream_key: null,
        stream_mode: 'rtmp_push',
        stream_type: ''
    });

    // Search, calendar, and filter state
    const [originalData, setOriginalData] = useState([]);
    const [showSearch, setShowSearch] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const searchRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [showCalendar, setShowCalendar] = useState(false);
    const calendarRef = useRef(null);
    const [dateRange, setDateRange] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection'
        }
    ]);

    const filterOptions = [
        { label: 'All', value: 'all' },
        { label: 'YouTube Only', value: 'youtube' },
        { label: 'CCTV – Internal', value: 'cctv' },
        { label: 'CCTV – External', value: 'cctv_external' },
        { label: 'Draft', value: 'draft' },
        { label: 'Live Now', value: 'live_now' },
        { label: 'Processing', value: 'processing' },
        { label: 'Recently Live', value: 'recently_live' },
        { label: 'Archived', value: 'archived' },
        { label: 'Featured', value: 'featured' },
        { label: 'Deity Darshan', value: 'live_darshan' },
        { label: 'Podcast', value: 'live_podcasts' },
        { label: 'Discourse', value: 'live_discourse' },
        { label: 'Aarti', value: 'live_aarti' },
        { label: 'Event Coverage', value: 'live_event_coverage' },
        { label: 'Pooja', value: 'live_pooja' },
    ];

    // Click outside handlers
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearch(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowCalendar(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Fetch data from API
    // Fetch data from API
    // Fetch data from API
    const fetchStreams = async () => {
        try {
            setLoading(true);
            const response = await _axios.get(`${ServerPath}/live-darshan/all`);

            if (response.data.success === 1) {
                const transformedData = response.data.data.map(item => {
                    const rawData = { ...item };

                    // Determine stream identifier based on type
                    const streamIdentifier = item.streamType === 'youtube'
                        ? item.youtubeVideoId
                        : item.streamType === 'cctv'
                            ? item.cctv?.streamKey
                            : item.cctv?.hlsUrl || 'external';

                    // Build flat relation arrays for display and edit pre-population
                    const relatedWaypoints = item.relatedWaypoints || [];
                    const relatedSaints = item.relatedSaints || [];
                    const relatedDeities = item.relatedDeities || [];
                    const relatedJourneys = item.relatedJourneys || [];
                    const relatedProjects = item.relatedProjects || [];

                    // Collect all relation names for the Relations column (cap at 3 + overflow)
                    const allRelations = [
                        ...relatedWaypoints.map(r => r.wptName),
                        ...relatedSaints.map(r => r.name),
                        ...relatedDeities.map(r => r.deityName),
                        ...relatedJourneys.map(r => r.tripName),
                        ...relatedProjects.map(r => r.projectTitle),
                    ];

                    return {
                        id: item.id,
                        wpt_id: item.wptId,
                        stream_type: item.streamType,
                        stream_key: item.cctv?.streamKey || null,
                        youtube_video_id: item.youtube?.videoId || null,
                        rtsp_url: item.cctv?.rtspUrl || null,
                        hls_url: item.cctv?.hlsUrl || null,
                        stream_title: item.streamTitle,
                        stream_title_mar: item.streamTitleMar,
                        stream_title_hin: item.streamTitleHin,
                        stream_title_guj: item.streamTitleGuj,
                        all_relations: allRelations,
                        relatedWaypoints,
                        relatedSaints,
                        relatedDeities,
                        relatedJourneys,
                        relatedProjects,
                        stream_identifier: streamIdentifier,
                        thumbnail_url: item.thumbnailUrl,
                        stream_status: item.streamStatus || 'draft',
                        health_status: item.healthStatus || null,
                        live_now_at: item.liveNowAt || null,
                        recently_live_at: item.recentlyLiveAt || null,
                        archived_at: item.archivedAt || null,
                        auto_convert: item.autoConvert || false,
                        converted_r2_url: item.convertedR2Url || null,
                        converted_artifact_id: item.convertedArtifactId || null,
                        is_featured: item.isFeatured ? 1 : 0,
                        stream_category: item.streamCategory || 'live_darshan',
                        orientation: item.orientation || 'portrait',
                        stream_start_at: item.streamStartAt || null,
                        stream_end_at: item.streamEndAt || null,
                        created_at: (item.createdAt || item.created_at)
                            ? new Date(item.createdAt || item.created_at).toLocaleDateString('en-GB')
                            : 'N/A',
                        updated_at: item.updatedAt || item.updated_at,
                        original_created_at: (item.createdAt || item.created_at)
                            ? new Date(item.createdAt || item.created_at)
                            : null,
                        action: (() => {
                            const streamStatus = item.streamStatus || 'draft';
                            const streamMode = item.cctv?.rtspUrl ? 'rtsp_pull' : 'rtmp_push';

                            if (streamStatus === 'draft') return (
                                <div className="d-flex justify-content-center gap-2">
                                    <button
                                        className="btn btn-link p-0"
                                        title="Go Live"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setModalConfig({
                                                type: 'go_live',
                                                title: 'Go Live Now',
                                                message: `Set "${item.streamTitle}" to Live Now?`,
                                                stream_id: item.id,
                                                stream_type: item.streamType,
                                                stream_mode: streamMode
                                            });
                                            setShowModal(true);
                                        }}
                                        style={{
                                            backgroundColor: '#4CAF50',
                                            borderRadius: '6px',
                                            padding: '6px',
                                            border: 'none',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <img src={Start} alt="go live" style={{ width: '24px', height: '24px' }} />
                                    </button>
                                    <button
                                        className="btn btn-link p-0"
                                        title="Edit"
                                        onClick={(e) => { e.stopPropagation(); handleEdit(rawData); }}
                                    >
                                        <img src={EditIcon} alt="edit" style={{ width: '24px', height: '24px' }} />
                                    </button>
                                </div>
                            );

                            if (streamStatus === 'live_now') return (
                                <div className="d-flex justify-content-center gap-2">
                                    <button
                                        className="btn btn-link p-0"
                                        title="Stop Stream"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setModalConfig({
                                                type: 'stop',
                                                title: 'Stop Stream',
                                                message: `Stop "${item.streamTitle}"?`,
                                                stream_id: item.id,
                                                stream_type: item.streamType,
                                                stream_mode: streamMode
                                            });
                                            setShowModal(true);
                                        }}
                                        style={{
                                            backgroundColor: '#FF4444',
                                            borderRadius: '6px',
                                            padding: '6px',
                                            border: 'none',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <img src={Stop} alt="stop" style={{ width: '24px', height: '24px' }} />
                                    </button>
                                    {item.streamType === 'youtube' && (
                                        <button
                                            className="btn btn-link p-0"
                                            title="Archive"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setModalConfig({
                                                    type: 'archive',
                                                    title: 'Archive Stream',
                                                    message: `Archive "${item.streamTitle}"?`,
                                                    stream_id: item.id,
                                                    stream_type: item.streamType,
                                                    stream_mode: streamMode
                                                });
                                                setShowModal(true);
                                            }}
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderRadius: '6px',
                                                padding: '6px',
                                                border: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <img src={ArchiveEnabled} alt="archive" style={{ width: '24px', height: '24px' }} />
                                        </button>
                                    )}
                                    {item.streamType === 'youtube' && (
                                        <button
                                            className="btn btn-link p-0"
                                            title="Make Recently Live"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setModalConfig({
                                                    type: 'make_recently_live',
                                                    title: 'Make Recently Live',
                                                    message: `Set "${item.streamTitle}" to Recently Live?`,
                                                    stream_id: item.id,
                                                    stream_type: item.streamType,
                                                    stream_mode: streamMode
                                                });
                                                setShowModal(true);
                                            }}
                                            style={{
                                                backgroundColor: '#009688',
                                                borderRadius: '6px',
                                                padding: '6px 10px',
                                                border: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                color: '#fff',
                                                fontSize: '12px',
                                                fontWeight: '600'
                                            }}
                                        >
                                            R.L
                                        </button>
                                    )}
                                    <button
                                        className="btn btn-link p-0"
                                        title="Edit"
                                        onClick={(e) => { e.stopPropagation(); handleEdit(rawData); }}
                                    >
                                        <img src={EditIcon} alt="edit" style={{ width: '24px', height: '24px' }} />
                                    </button>
                                </div>
                            );

                            if (streamStatus === 'processing') return (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#FF9800', fontWeight: '600' }}>
                                    <div style={{ width: '12px', height: '12px', borderRadius: '50%', border: '2px solid #FF9800', borderTopColor: 'transparent', animation: 'spin 0.8s linear infinite' }} />
                                    Processing
                                </div>
                            );

                            if (streamStatus === 'recently_live') return (
                                <div className="d-flex justify-content-center gap-2">
                                    {item.streamType === 'youtube' && (
                                        <button
                                            className="btn btn-link p-0"
                                            title="Go Live"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setModalConfig({
                                                    type: 'go_live',
                                                    title: 'Go Live Now',
                                                    message: `Set "${item.streamTitle}" to Live Now?`,
                                                    stream_id: item.id,
                                                    stream_type: item.streamType,
                                                    stream_mode: streamMode
                                                });
                                                setShowModal(true);
                                            }}
                                            style={{
                                                backgroundColor: '#4CAF50',
                                                borderRadius: '6px',
                                                padding: '6px',
                                                border: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <img src={Start} alt="go live" style={{ width: '24px', height: '24px' }} />
                                        </button>
                                    )}
                                    {item.streamType === 'youtube' && (
                                        <button
                                            className="btn btn-link p-0"
                                            title="Archive"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setModalConfig({
                                                    type: 'archive',
                                                    title: 'Archive Stream',
                                                    message: `Archive "${item.streamTitle}"?`,
                                                    stream_id: item.id,
                                                    stream_type: item.streamType,
                                                    stream_mode: streamMode
                                                });
                                                setShowModal(true);
                                            }}
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderRadius: '6px',
                                                padding: '6px',
                                                border: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <img src={ArchiveEnabled} alt="archive" style={{ width: '24px', height: '24px' }} />
                                        </button>
                                    )}
                                    <button
                                        className="btn btn-link p-0"
                                        title="Edit"
                                        onClick={(e) => { e.stopPropagation(); handleEdit(rawData); }}
                                    >
                                        <img src={EditIcon} alt="edit" style={{ width: '24px', height: '24px' }} />
                                    </button>
                                    {item.convertedArtifactId && (
                                        <button
                                            className="btn btn-link p-0"
                                            title="View Recording"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                window.open(`/artifacts/${item.convertedArtifactId}`, '_blank');
                                            }}
                                            style={{
                                                backgroundColor: '#2196F3',
                                                borderRadius: '6px',
                                                padding: '6px',
                                                border: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            🔗
                                        </button>
                                    )}
                                </div>
                            );

                            // archived + default
                            return (
                                <div className="d-flex justify-content-center gap-2">
                                    {streamStatus === 'archived' && item.streamType === 'youtube' && (
                                        <button
                                            className="btn btn-link p-0"
                                            title="Make Recently Live"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setModalConfig({
                                                    type: 'make_recently_live',
                                                    title: 'Make Recently Live',
                                                    message: `Set "${item.streamTitle}" to Recently Live?`,
                                                    stream_id: item.id,
                                                    stream_type: item.streamType,
                                                    stream_mode: streamMode
                                                });
                                                setShowModal(true);
                                            }}
                                            style={{
                                                backgroundColor: '#009688',
                                                borderRadius: '6px',
                                                padding: '6px 10px',
                                                border: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                color: '#fff',
                                                fontSize: '12px',
                                                fontWeight: '600'
                                            }}
                                        >
                                            R.L
                                        </button>
                                    )}
                                    <button
                                        className="btn btn-link p-0"
                                        title="Edit"
                                        onClick={(e) => { e.stopPropagation(); handleEdit(rawData); }}
                                    >
                                        <img src={EditIcon} alt="edit" style={{ width: '24px', height: '24px' }} />
                                    </button>
                                </div>
                            );
                        })(),
                        raw_data: rawData
                    };
                });

                setData(transformedData);
                setOriginalData(transformedData);
                setTotalRows(transformedData.length);
            } else {
                toast.error('Failed to fetch streams');
            }
        } catch (error) {
            console.error('Error fetching streams:', error);
            toast.error('Error fetching streams');
        } finally {
            setLoading(false);
        }
    };

    // Load data on component mount
    useEffect(() => {
        fetchStreams();
    }, []);

    // Search, filter and date range functions
    const handleSearch = (value) => {
        setSearchValue(value);
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(value, selectedFilter, currentDateRange);
    };

    const handleFilterChange = (value) => {
        setSelectedFilter(value);
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(searchValue, value, currentDateRange);
        setShowDropdown(false);
    };

    const handleDateRangeChange = (item) => {
        setDateRange([item.selection]);
        applyFiltersAndSearch(searchValue, selectedFilter, item.selection);
    };

    const clearDateFilter = () => {
        const clearedRange = {
            startDate: null,
            endDate: null,
            key: 'selection'
        };
        setDateRange([clearedRange]);
        applyFiltersAndSearch(searchValue, selectedFilter, null);
        setShowCalendar(false);
    };

    const applyFiltersAndSearch = (searchValue, filterValue, dateValue) => {
        let filteredData = [...originalData];

        // Apply search filter
        if (searchValue && searchValue.trim()) {
            const searchTerm = searchValue.toLowerCase();
            filteredData = filteredData.filter(item => {
                return (
                    String(item.temple_name || '').toLowerCase().includes(searchTerm) ||
                    String(item.stream_title || '').toLowerCase().includes(searchTerm) ||
                    String(item.stream_identifier || '').toLowerCase().includes(searchTerm) ||
                    String(item.stream_type || '').toLowerCase().includes(searchTerm)
                );
            });
        }

        // Apply type/status filter
        if (filterValue && filterValue !== 'all') {
            switch (filterValue) {
                case 'youtube':
                    filteredData = filteredData.filter(item => item.stream_type === 'youtube');
                    break;
                case 'cctv':
                    filteredData = filteredData.filter(item => item.stream_type === 'cctv');
                    break;
                case 'cctv_external':
                    filteredData = filteredData.filter(item => item.stream_type === 'cctv_external');
                    break;
                case 'draft':
                    filteredData = filteredData.filter(item => item.stream_status === 'draft');
                    break;
                case 'live_now':
                    filteredData = filteredData.filter(item => item.stream_status === 'live_now');
                    break;
                case 'processing':
                    filteredData = filteredData.filter(item => item.stream_status === 'processing');
                    break;
                case 'recently_live':
                    filteredData = filteredData.filter(item => item.stream_status === 'recently_live');
                    break;
                case 'archived':
                    filteredData = filteredData.filter(item => item.stream_status === 'archived');
                    break;
                case 'featured':
                    filteredData = filteredData.filter(item => item.is_featured === 1);
                    break;
                case 'live_darshan':
                    filteredData = filteredData.filter(item => item.stream_category === 'live_darshan');
                    break;
                case 'live_podcasts':
                    filteredData = filteredData.filter(item => item.stream_category === 'live_podcasts');
                    break;
                case 'live_discourse':
                    filteredData = filteredData.filter(item => item.stream_category === 'live_discourse');
                    break;
                case 'live_aarti':
                    filteredData = filteredData.filter(item => item.stream_category === 'live_aarti');
                    break;
                case 'live_event_coverage':
                    filteredData = filteredData.filter(item => item.stream_category === 'live_event_coverage');
                    break;
                case 'live_pooja':
                    filteredData = filteredData.filter(item => item.stream_category === 'live_pooja');
                    break;
                default:
                    break;
            }
        }

        // Apply date filter
        if (dateValue?.startDate && dateValue?.endDate) {
            filteredData = filteredData.filter(item => {
                if (!item.original_created_at) return false;
                const startDate = new Date(dateValue.startDate);
                startDate.setHours(0, 0, 0, 0);
                const endDate = new Date(dateValue.endDate);
                endDate.setHours(23, 59, 59, 999);
                return item.original_created_at >= startDate && item.original_created_at <= endDate;
            });
        }

        setData(filteredData);
    };
    // Handle stream operations
    const handleGoLive = async (stream_id, stream_type, stream_mode) => {
        try {
            if (stream_type === 'cctv') {
                // const endpoint = stream_mode === 'rtsp_pull'
                //     ? `${ServerPath}/live-darshan/cctv/start`
                //     : `${ServerPath}/live-darshan/cctv/activate`;
                const endpoint = `${ServerPath}/live-darshan/cctv/start`;
                const response = await _axios.post(endpoint, { stream_id });
                if (response.data.success === 1) {
                    toast.success('Stream is now Live');
                    fetchStreams();
                } else {
                    toast.error(response.data.message || 'Failed to go live');
                }
            } else {
                const response = await _axios.post(
                    `${ServerPath}/live-darshan/update-status`,
                    { stream_id, stream_status: 'live_now' }
                );
                if (response.data.success === 1) {
                    toast.success('Stream is now Live');
                    fetchStreams();
                } else {
                    toast.error(response.data.message || 'Failed to go live');
                }
            }
        } catch (error) {
            console.error('Error going live:', error);
            toast.error(error.response?.data?.message || 'Error going live');
        }
    };

    const handleArchiveStream = async (stream_id) => {
        try {
            const response = await _axios.post(
                `${ServerPath}/live-darshan/update-status`,
                { stream_id, stream_status: 'archived' }
            );
            if (response.data.success === 1) {
                toast.success('Stream archived');
                fetchStreams();
            } else {
                toast.error(response.data.message || 'Failed to archive stream');
            }
        } catch (error) {
            console.error('Error archiving stream:', error);
            toast.error(error.response?.data?.message || 'Error archiving stream');
        }
    };

    const handleMakeRecentlyLive = async (stream_id) => {
        try {
            const response = await _axios.post(
                `${ServerPath}/live-darshan/update-status`,
                { stream_id, stream_status: 'recently_live' }
            );
            if (response.data.success === 1) {
                toast.success('Stream set to Recently Live');
                fetchStreams();
            } else {
                toast.error(response.data.message || 'Failed to update stream');
            }
        } catch (error) {
            console.error('Error updating stream:', error);
            toast.error(error.response?.data?.message || 'Error updating stream');
        }
    };

    const handleStopStream = async (stream_id, stream_type, stream_mode) => {
        try {
            if (stream_type === 'cctv') {
                const response = await _axios.post(
                    `${ServerPath}/live-darshan/cctv/stop`, { stream_id }
                );
                if (response.data.success === 1) {
                    toast.success('Stream stopped');
                    fetchStreams();
                } else {
                    toast.error(response.data.message || 'Failed to stop stream');
                }
            } else {
                const response = await _axios.post(
                    `${ServerPath}/live-darshan/update-status`,
                    { stream_id, stream_status: 'draft' }
                );
                if (response.data.success === 1) {
                    toast.success('Stream stopped');
                    fetchStreams();
                } else {
                    toast.error(response.data.message || 'Failed to stop stream');
                }
            }
        } catch (error) {
            console.error('Error stopping stream:', error);
            toast.error(error.response?.data?.message || 'Error stopping stream');
        }
    };

    // Handle edit action
    // Handle edit action
    const handleEdit = (rawData) => {
        console.log('Edit row data (raw):', rawData);

        // Transform camelCase API data to snake_case for edit form
        const editData = {
            id: rawData.id,
            wpt_id: rawData.wptId || rawData.wpt_id,
            stream_type: rawData.streamType || rawData.stream_type,
            stream_category: rawData.streamCategory || rawData.stream_category || 'live_darshan',

            // YouTube fields
            youtube_video_id: rawData.youtubeVideoId || rawData.youtube_video_id || '',

            // CCTV fields
            stream_key: rawData.cctv?.streamKey || rawData.stream_key || '',
            rtsp_url: rawData.cctv?.rtspUrl || rawData.rtsp_url || '',
            hls_url: rawData.cctv?.hlsUrl || rawData.hls_url || '',

            // Lifecycle fields
            stream_status: rawData.streamStatus || rawData.stream_status || 'draft',
            health_status: rawData.healthStatus || rawData.health_status || null,
            auto_convert: rawData.autoConvert || rawData.auto_convert || false,
            converted_artifact_id: rawData.convertedArtifactId || rawData.converted_artifact_id || null,
            converted_r2_url: rawData.convertedR2Url || rawData.converted_r2_url || null,
            live_now_at: rawData.liveNowAt || rawData.live_now_at || null,
            recently_live_at: rawData.recentlyLiveAt || rawData.recently_live_at || null,
            archived_at: rawData.archivedAt || rawData.archived_at || null,

            // Shared fields
            stream_title: rawData.streamTitle || rawData.stream_title || '',
            stream_title_mar: rawData.streamTitleMar || rawData.stream_title_mar || '',
            stream_title_hin: rawData.streamTitleHin || rawData.stream_title_hin || '',
            stream_title_guj: rawData.streamTitleGuj || rawData.stream_title_guj || '',
            thumbnail_url: rawData.thumbnailUrl || rawData.thumbnail_url || '',

            is_featured: rawData.isFeatured !== undefined ? (rawData.isFeatured ? 1 : 0) : (rawData.is_featured !== undefined ? rawData.is_featured : 0),
            enableMultiView: rawData.enableMultiView !== undefined ? Boolean(rawData.enableMultiView) : Boolean(rawData.enable_multi_view),

            created_at: rawData.created_at,
            updated_at: rawData.updated_at,
            orientation: rawData.orientation || 'portrait',

            // Relation arrays for pre-populating edit form
            relatedWaypoints: rawData.relatedWaypoints || [],
            relatedSaints: rawData.relatedSaints || [],
            relatedDeities: rawData.relatedDeities || [],
            relatedJourneys: rawData.relatedJourneys || [],
            relatedProjects: rawData.relatedProjects || [],

            // New fields
            maxQuality: rawData.maxQuality || null,
            displaySponsor: rawData.displaySponsor || false,
            sponsor1Name: rawData.sponsor1Name || null,
            sponsor1NameMar: rawData.sponsor1NameMar || null,
            sponsor1NameHin: rawData.sponsor1NameHin || null,
            sponsor1NameGuj: rawData.sponsor1NameGuj || null,
            sponsor2Name: rawData.sponsor2Name || null,
            sponsor2NameMar: rawData.sponsor2NameMar || null,
            sponsor2NameHin: rawData.sponsor2NameHin || null,
            sponsor2NameGuj: rawData.sponsor2NameGuj || null,
            sponsor1Image: rawData.sponsor1Image || null,
            sponsor1Info: rawData.sponsor1Info || null,
            sponsor1InfoMar: rawData.sponsor1InfoMar || null,
            sponsor1InfoHin: rawData.sponsor1InfoHin || null,
            sponsor1InfoGuj: rawData.sponsor1InfoGuj || null,
            sponsor2Image: rawData.sponsor2Image || null,
            sponsor2Info: rawData.sponsor2Info || null,
            sponsor2InfoMar: rawData.sponsor2InfoMar || null,
            sponsor2InfoHin: rawData.sponsor2InfoHin || null,
            sponsor2InfoGuj: rawData.sponsor2InfoGuj || null,
            stream_start_at: rawData.streamStartAt || rawData.stream_start_at || null,
            stream_end_at: rawData.streamEndAt || rawData.stream_end_at || null,
            originalSound: rawData.originalSound,
            audio: rawData.audio || null,
            aartiConfig: rawData.aartiConfig || [],

            // Live stream animation
            enableAnimation: rawData.enableAnimation ?? rawData.enable_animation ?? 0,
            animationUrls: rawData.animationUrls ?? rawData.animation_urls ?? null,
        };

        console.log('Edit data (transformed):', editData);
        setEditRowData(editData);
        setShowEdit(true);
    };

    // Handle row selection
    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    // Handle pagination
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };

    // Handle modal confirmation
    const handleModalConfirm = async () => {
        if (modalConfig.type === 'go_live') {
            await handleGoLive(modalConfig.stream_id, modalConfig.stream_type, modalConfig.stream_mode);
        } else if (modalConfig.type === 'stop') {
            await handleStopStream(modalConfig.stream_id, modalConfig.stream_type, modalConfig.stream_mode);
        } else if (modalConfig.type === 'archive') {
            await handleArchiveStream(modalConfig.stream_id);
        } else if (modalConfig.type === 'make_recently_live') {
            await handleMakeRecentlyLive(modalConfig.stream_id);
        }
        setShowModal(false);
    };

    // Component closing handlers
    const handleEditClose = () => {
        setShowEdit(false);
        setEditRowData(null);
        fetchStreams();
    };

    const handleCreateClose = () => {
        setShowCreate(false);
        fetchStreams();
    };


    return (
        <Fragment>
            <style>{tableStyles}</style>
            <Container fluid={true}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="mb-0">Live Temple Darshan Management</h3>
                    <div className="d-flex align-items-center gap-3">
                        {/* Search Component */}
                        <div className="position-relative" ref={searchRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowSearch(true)}
                            >
                                <img src={Search} alt="search" style={{ width: '36px', height: '36px' }} />
                            </button>
                            {showSearch && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '45px',
                                        left: '-180px',
                                        width: '220px',
                                        zIndex: 1000
                                    }}
                                >
                                    <div
                                        style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            padding: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                background: '#F8F7FA',
                                                borderRadius: '6px',
                                                padding: '6px 12px'
                                            }}
                                        >
                                            <input
                                                type="text"
                                                placeholder="Search Here..."
                                                value={searchValue}
                                                onChange={(e) => handleSearch(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    background: 'transparent',
                                                    fontSize: '14px',
                                                    color: '#666',
                                                    outline: 'none'
                                                }}
                                                autoFocus
                                            />
                                            <button
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                                onClick={() => handleSearch(searchValue)}
                                            >
                                                <img src={SearchIcon} alt="search" style={{ width: '20px', height: '20px' }} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Calendar Component */}
                        <div className="position-relative" ref={calendarRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowCalendar(!showCalendar)}
                            >
                                <img src={Calendar} alt="calendar" style={{ width: '36px', height: '36px' }} />
                            </button>
                            {showCalendar && (
                                <div
                                    className="position-absolute end-0 mt-2 bg-white rounded shadow p-3"
                                    style={{
                                        width: 'auto',
                                        maxWidth: '300px',
                                        zIndex: 1000,
                                        right: 0
                                    }}
                                >
                                    <style>
                                        {`
                                            .date-range {
                                                font-size: 12px !important;
                                            }
                                            .date-range .rdrMonth {
                                                width: 240px !important;
                                                padding: 0 !important;
                                            }
                                            .date-range .rdrCalendarWrapper {
                                                font-size: 12px !important;
                                                width: 240px !important;
                                                border-radius: 8px !important;
                                                overflow: hidden !important;
                                                background: white !important;
                                            }
                                            .date-range .rdrDateDisplayWrapper {
                                                display: none !important;
                                            }
                                            .rdrMonthAndYearWrapper {
                                                padding-top: 5px !important;
                                                height: 40px !important;
                                            }
                                            .rdrMonth {
                                                padding: 0 !important;
                                            }
                                        `}
                                    </style>
                                    <DateRange
                                        editableDateInputs={true}
                                        onChange={handleDateRangeChange}
                                        moveRangeOnFirstSelection={false}
                                        ranges={dateRange}
                                        maxDate={new Date()}
                                        months={1}
                                        direction="horizontal"
                                        className="date-range"
                                        staticRanges={[]}
                                        inputRanges={[]}
                                        rangeColors={['#0066ff']}
                                        minDate={new Date("2000-01-01")}
                                        showSelectionPreview={true}
                                        showMonthAndYearPickers={true}
                                        monthDisplayFormat="MMMM yyyy"
                                        dayDisplayFormat="d"
                                        showDateDisplay={false}
                                        monthsShown={1}
                                    />
                                    <div className="d-flex justify-content-end mt-2">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={clearDateFilter}
                                        >
                                            Clear
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Filter Component */}
                        <div className="position-relative" ref={dropdownRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowDropdown(!showDropdown)}
                            >
                                <img src={Filter} alt="filter" style={{ width: '36px', height: '36px' }} />
                            </button>
                            {showDropdown && (
                                <div className="position-absolute end-0 mt-2 bg-white rounded shadow p-2"
                                    style={{ width: '200px', zIndex: 1000 }}>
                                    <style>
                                        {`
                                            .form-check-label {
                                                font-weight: 400 !important;
                                            }
                                            .form-check-input[type=checkbox] {
                                                border-radius: 0 !important;
                                            }
                                        `}
                                    </style>
                                    <Form>
                                        {filterOptions.map((option) => (
                                            <Form.Check
                                                key={option.value}
                                                type="checkbox"
                                                name="filterOption"
                                                id={`filter-${option.value}`}
                                                label={option.label}
                                                checked={selectedFilter === option.value}
                                                onChange={() => handleFilterChange(option.value)}
                                            />
                                        ))}
                                    </Form>
                                </div>
                            )}
                        </div>

                        {/* Create Button */}
                        <Button
                            variant="primary"
                            onClick={() => setShowCreate(true)}
                            className="bg-primary"
                        >
                            Add New Stream
                        </Button>
                    </div>
                </div>

                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <DataTable
                                    columns={tableColumns}
                                    data={data}
                                    selectableRows
                                    pagination
                                    paginationServer={false}
                                    paginationTotalRows={totalRows}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onSelectedRowsChange={handleRowSelected}
                                    clearSelectedRows={toggleDelete}
                                    progressPending={loading}
                                    highlightOnHover
                                    responsive
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Create Stream Modal */}
            {showCreate && <CreateLiveStream show={showCreate} onHide={handleCreateClose} />}

            {/* Edit Stream Modal */}
            {showEdit && <EditLiveStream
                key={editRowData?.id || 'new-edit'}
                show={showEdit}
                onHide={handleEditClose}
                streamData={editRowData}
            />}

            {/* Confirmation Modal */}
            <ConfirmationModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onConfirm={handleModalConfirm}
                title={modalConfig.title}
                message={modalConfig.message}
                modalType={modalConfig.type}
                streamType={modalConfig.stream_type}
                streamMode={modalConfig.stream_mode}
            />
        </Fragment>
    );
};

// Confirmation Modal Component
const ConfirmationModal = ({ show, onHide, onConfirm, title, message, modalType, streamType, streamMode }) => {
    const streamTypeBadge = (() => {
        if (modalType !== 'go_live') return null;
        const config = {
            youtube: { label: 'YouTube', bg: '#FF0000', color: '#fff' },
            cctv: { label: 'Internal', bg: '#00BCD4', color: '#fff' },
            cctv_external: { label: 'External', bg: '#FF9800', color: '#fff' },
        }[streamType] || { label: streamType, bg: '#9E9E9E', color: '#fff' };
        return (
            <span style={{
                display: 'inline-block', fontSize: '11px', fontWeight: '600',
                padding: '3px 10px', borderRadius: '20px',
                background: config.bg, color: config.color
            }}>
                {config.label}
            </span>
        );
    })();

    const latencyBadge = (() => {
        if (modalType !== 'stop' || streamType !== 'cctv') return null;
        return (
            <span style={{
                display: 'inline-block', fontSize: '11px', fontWeight: '600',
                padding: '3px 10px', borderRadius: '20px',
                background: streamMode === 'rtsp_pull' ? '#FFF3E0' : '#E8F5E9',
                color: streamMode === 'rtsp_pull' ? '#E65100' : '#2E7D32'
            }}>
                {streamMode === 'rtsp_pull' ? '⚠ RTSP Pull — 15–30s latency' : '✓ RTMP Push — 3–5s latency'}
            </span>
        );
    })();

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Body className="text-center p-4">
                <div className="mb-4">
                    <div className="rounded-circle bg-warning bg-opacity-10 d-inline-flex p-4 mb-3">
                        <i className="bi bi-exclamation-lg fs-4 text-warning"></i>
                    </div>
                    <h4>{title}</h4>
                    <p className="text-secondary mb-0">{message}</p>
                    {(streamTypeBadge || latencyBadge) && (
                        <div style={{ marginTop: '10px' }}>
                            {streamTypeBadge}
                            {latencyBadge}
                        </div>
                    )}
                </div>
                <div className="d-flex gap-2 justify-content-center">
                    <Button variant="primary" className="px-4" onClick={onConfirm}>Yes</Button>
                    <Button variant="danger" className="px-4" onClick={onHide}>Cancel</Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default LiveStreamTable;